import ContentLoader from "@funded-here-interface/common/src/components/ContentLoader/ContentLoader";
import { IconPhotoDollar, IconSignature, IconCoin, IconInfoHexagon } from "@tabler/icons-react";
import { FC, ReactNode, Suspense } from "react";

import AdminNavBar, { IMenuItem } from "../../components/AdminNavBar/AdminNavBar";
import { useStyles } from "./SalesSupportLayout.styles";

interface IProps {
  content: ReactNode;
}

export const salesSupportMenus: IMenuItem[] = [
  {
    label: "Onboarding",
    path: "/onboarding",
    icon: IconSignature,
  },
  {
    label: "Collaboration Proposal",
    path: "/sales-support/application",
    icon: IconPhotoDollar,
  },
  {
    label: "Funding Limit Details",
    path: "/sales-support/funding-limit-details",
    icon: IconInfoHexagon,
  },
  {
    label: "Collection Accounts",
    path: "/merchant-collection-accounts",
    icon: IconCoin,
  },
];

const SalesSupportLayout: FC<IProps> = ({ content }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.mainContainer}>
      <AdminNavBar menus={salesSupportMenus} userRole="Customer Success Coordinator" />
      <div style={{ paddingBottom: "30px" }} className={classes.hero}>
        <Suspense fallback={<ContentLoader />}>{content}</Suspense>
      </div>
    </div>
  );
};

export default SalesSupportLayout;
